module.exports = __webpack_public_path__ + "static/media/google-play.0d6b1725.png";